import * as React from 'react'

// Lazy on purpose: react-to-print's UMD wrapper can be bundled before Module
// Federation's eager shared ReactDOM binding is ready, leaving undefined
// minified bindings in the desktop bootstrap chunk.
const LazyReactToPrint = React.lazy(async () => ({
  default: (await import('react-to-print')).default,
}))

type ReactToPrintProps = React.ComponentProps<typeof LazyReactToPrint>

export const ReactToPrint: React.FC<ReactToPrintProps> = props => (
  <React.Suspense fallback={null}>
    <LazyReactToPrint {...props} />
  </React.Suspense>
)
